import React, { useRef, useEffect } from "react";
import Heading from "./Heading";
import useResizeObserver from "../utils/useResizeObserver";
import "../style/Section.scss";
// import "../style/Section.css";
// import top from "../top.jpg";

const Section = (props) => {
  const { text, text_m, imgurl, bg, icon } = props;
  const widthRef = useRef(null);
  const { width, height } = useResizeObserver(widthRef);

  return (
    <div className={"section-container"} ref={widthRef}>
      <div className="splitter"></div>

      {/* <div className="splitter-icon">
        <img
          className={`section-icon`}
          src={`${process.env.PUBLIC_URL + "/" + icon}`}
        />{" "}
      </div> */}

      <div className="section-box">
        <h1
          className={`section-hed`}
          dangerouslySetInnerHTML={{ __html: width > 900 ? text : text_m }}
        ></h1>
      </div>
    </div>
  );
};

// `url(${process.env.PUBLIC_URL + "/top.jpg"})`,

export default Section;
